import type { Course, Subject, Teachable } from '@/types/composition-functions';

type EntryLike = { teachable?: Teachable | null; custom_title?: string | null };

export function teachableName(entry: EntryLike | null | undefined): string {
  const t = entry?.teachable;
  if (!t) return '';
  if ('course_title' in t) return (t as Course).course_title;
  if ('name' in t) return (t as Subject).name;
  return '';
}

export function teachableId(entry: EntryLike | null | undefined): string | null {
  return entry?.teachable?.id ?? null;
}
